export const MOCK_DATA = [
	{
		date: '2022-03-11 20:09:14',
		content: `หลังจากที่เคยบูชาเส้นก่อนใส่ติดตัวตลอด มีแต่เรื่องดีๆ ปังๆเข้ามาเลยบูชาพระแม่อุมาเพิ่ม การบูชาท่านจะเด่นในเรื่องการเลื่อนขั้นหน้าที่การงาน ความรัก ครอบครัว และเรื่องการขอบุตร เดี๋ยวไว้ปังยังไง จะมาบอกเล่ากันอีกที ส่วนตัวที่บูชาท่านแล้วรู้สึกเรื่องดีๆ เข้ามาเต็มไปหมด 🥰
		#สายมู`,
		labels: ['religion'],
	},
	{
		date: '2022-03-11 20:09:14',
		content: `#DSIแตงโม สรุปลุงอัจ
			1.มีพันตำรวจเอกให้การรับสารภาพว่าแตงโมไม่ได้ฉี่ท้ายเรือ
			2.พลตต.ตเต๋ายุเบื้องหลัง
			3.มีการเปลี่ยนความเร็วเรือจาก12 เป็น20กิโลเมตรต่อช.ม
			4.มีการขโมยศพตมด้วย
			5.ให้ไปถามหมอคนสวยทำอะไรกับศพหมอมีเอี่ยว
			6.ทำกันเป็นขบวนการ
			7.มีเรือสองลำ
			8.มีการเปลี่ยนแปลงผลชันสูตรนิติเวช`,
		labels: ['politics'],
	},
	{
		date: '2022-04-18 20:09:14',
		content:
			'การแก้ปัญหาน้ำท่วมต้องทำทั้งระบบตั้งแต่ “เส้นเลือดฝอย” ระบบท่อระบายน้ำ ปั๊มสูบน้ำ ขยะ จนถึง “เส้นเลือดใหญ่” ระบบอุโมงค์ยักษ์ ขุดลอกคลอง และดูแลระดับน้ำ ประตูน้ำ   ทำกรุงเทพฯ ไม่ให้ท่วมเมื่อฝนมา  หาคำว่า “ระบายน้ำ” ใน  https://t.co/VWNpbU6fNc จะพบ 7 นโยบายที่เกี่ยวข้องครับ  https://t.co/x00L6uIAxq',
		labels: ['politics'],
	},
	{
		date: '2022-04-18 17:54:37',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-18 17:54:23',
		content:
			'มาเป็นเด็กสยามวันนึงครับ  #ชัชชาติ #ชัช8าติ  https://t.co/DSrEX589eC',
		labels: ['first_name', 'politics'],
	},
	{
		date: '2022-04-18 13:18:36',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ อาคาร Mint Tower ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-18 13:17:20',
		content:
			'นโยบาย “ปลอดภัยดี” มองความปลอดภัยครอบคลุมมิติอาชญากรรม การจราจร และสาธารณภัย ใช้ข้อมูลลดจุดเสี่ยง มีเทคโนโลยีเป็นตัวช่วยตรวจสอบความผิดปกติต่างๆ พัฒนากายภาพของเมืองให้เหมาะสม รวมถึงมีแผนพร้อมรับมือกับเหตุการณ์ไม่คาดคิด เพื่อกรุงเทพฯที่ปลอดภัย  อ่านต่อได้ที่  https://t.co/thKsKudCUB  https://t.co/OToDoyNP8x',
		labels: ['politics'],
	},
	{
		date: '2022-04-13 09:58:34',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-13 09:58:19',
		content:
			'“อยากให้ฟังเพลงแล้วมีรอยยิ้ม มีความหวัง” สวัสดีปีใหม่ไทย สงกรานต์ ๒๕๖๕ ขอให้พวกเราทุกคนมีสุขภาพร่างกายที่แรง จิตใจที่แจ่มใส มีความสุขมากๆ ครับ #ชัชชาติ #ชัช8าติ  https://t.co/kSWpmK4xrk',
		labels: ['first_name', 'politics'],
	},
	{
		date: '2022-04-18 13:17:20',
		content:
			'นโยบาย “ปลอดภัยดี” มองความปลอดภัยครอบคลุมมิติอาชญากรรม การจราจร และสาธารณภัย ใช้ข้อมูลลดจุดเสี่ยง มีเทคโนโลยีเป็นตัวช่วยตรวจสอบความผิดปกติต่างๆ พัฒนากายภาพของเมืองให้เหมาะสม รวมถึงมีแผนพร้อมรับมือกับเหตุการณ์ไม่คาดคิด เพื่อกรุงเทพฯที่ปลอดภัย  อ่านต่อได้ที่  https://t.co/thKsKudCUB  https://t.co/OToDoyNP8x',
		labels: ['politics'],
	},
	{
		date: '2022-04-27 07:29:44',
		content:
			'พี่ก็อตตตตตตต คือทำไปได้  เมื่อฮีอยากเรียกยอดไลค์ด้วยการลงรูป Sexy โอเค แล้วแต่พี่สบายใจเลยยยย  #ก็อตจิรายุทธ #ใต้เตียงดารา  https://t.co/UcVnSuZt9f',
		labels: ['sexual', 'religion', 'health', 'politics'],
	},
	{
		date: '2022-04-25 21:09:06',
		content:
			'อ๊อยยยยยย ในจอเขินเฮียต้า นอกจอก็เขินพี่เดี่ยวววว  ช่วงนี้พี่เค้ากลับมาฟิตด้วยการว่ายน้ำนะ วิวกรุงเทพคือดีไม่ไหวจริงๆ   #เดี่ยวสุริยนต์ #ซ่านเสน่หาep11  https://t.co/vTvoxylcjy',
		labels: ['politics', 'religion'],
	},
	{
		date: '2022-04-25 13:31:21',
		content:
			'ที่มาของคำว่าแม่ก็คือแม่ ตำนานตลอดไปที่แท้ทรู #อั้มพัชราภา กับเซตสีแสดของเธอ   นานๆทีจะเห็นแม่ใส่บิกินี่ แต่มาแต่ละทีก็ไม่ทำให้ผิดหวัง ก็สับๆโชว์เอว 23 ไปเลยสิคะ ใดใดคือหน้าชีอั้มโกงอายุมากเรียกน้องอั้มได้ไม่ติดดด  https://t.co/87Ii7R5HcA',
		labels: ['health'],
	},
	{
		date: '2022-04-21 14:18:30',
		content:
			'วี้ดดดดดด ใครที่เดาว่าไปยุโรปรอบนี้ #หมากคิม จะมีข่าวดีหรือเปล่า!!  ใช่ค่าาาา มีจริงๆด้วย พี่หมากบอกผมพร้อมแล้ว เราสองคนพร้อมแล้ว ขอแต่งแล้วจ้าาาส จุดพลุได้!!!  ปล. แหวนใหญ่กระแทกตามากๆ 55555555  #ใต้เตียงดารา  https://t.co/aPNCkf7ZKo',
		labels: ['religion'],
	},
	{
		date: '2022-04-17 22:44:47',
		content:
			'คอนแกรททูเลชั่นกับครอบครัวดีนส์  หลังจากแดดดี๊แมทธิวอ้อนแม่ลิเดียเรื่องลูกคนที่ 3 อยู่นาน มาวันนี้ประสบความสำเร็จแล้วจ้าาา ลูกมังกรตัวสุดท้ายกำลังมา นุ้งแป๋วแหววของเราจะได้เป็นเจ้แล้ววว  #ใต้เตียงดารา  https://t.co/FBKK9gH11x',
		labels: ['none'],
	},
	{
		date: '2022-04-17 10:01:19',
		content: 'แบบสับ   #MILLILiveatCoachella  https://t.co/EefZBLqREM',
		labels: ['sexual'],
	},
	{
		date: '2022-04-17 09:58:54',
		content:
			'สุดปัง ปัง ปังปะรังปังปี้ ยัยนวย MILLI ในงานเทศกาลดนตรีและศิลปะระดับโลก coachella 2022 กรี๊ดดดดดมาก   นุ้งเป็นศิลปินเดี่ยวคนไทยคนแรกในเทศกาลนี้ นอกจากจะไปร้องแร็ปโชว์ ยัยนวยกินข้าวเหนียวมะม่วงโชว์ด้วยอีกหนึ่ง เริ่ดดดดด    #MILLILiveatCoachella  https://t.co/y4qJDZIcMg',
		labels: ['none'],
	},
	{
		date: '2022-04-16 20:55:02',
		content:
			'#ใบเฟิร์นพิมพ์ชนก จะสู้พี่แบร์ได้ หนูต้องเลิกเขินพี่ญ่าก่อนลูกกกกก เอ็นดู #ใบญ่า น่ารักกกกกก  #ใบเฟิร์นญาญ่า #ณเดชน์ญาญ่า #ญาญ่า  https://t.co/8SC0tPbjXX',
		labels: ['none'],
	},
	{
		date: '2022-04-16 20:05:20',
		content:
			'เรือ #ณเดชน์ญาญ่า หรือ #นายใบเฟิร์น หรอจะสู้ #ใบเฟิร์นญาญ่า  โอ๊ยเอ็นดู นุ้งใบคือเค้ารักญ่าของเค้าจริงๆ   “วันนั้นถ่ายงานแล้วญ่าขึ้นมาหา เคยเห็นเด็กผู้ชายที่ทำท่าทางไม่ถูกเวลาจะแกล้งเด็กผู้หญิงที่เขาชอบมั้ย เขินมาก เกร็งมาก ต่อหน้าญ่าไม่กล้าพูด แต่ถ้าญ่าเดินผ่านก็จะเลิฟยู”  https://t.co/XVQB4vDg6q',
		labels: ['none'],
	},
	{
		date: '2022-04-15 14:05:06',
		content:
			'อีกหนึ่งเจ้าหญิงแห่งวงการใต้ท้องทะเล ยกให้นางเงือกชีเกรซ  กาญจน์เกล้า  บนบกก็ว่ารูปดีแล้วรูปใต้น้ำก็คือจึ้ง!!!  ฟิลลิ่งชั้นคือแอเรียลว่ายน้ำเล่นกับน้องปลา   #ใต้เตียงดารา  https://t.co/4JXgnCnvPg',
		labels: ['none'],
	},
	{
		date: '2022-04-11 17:29:57',
		content:
			'เกินเรื่องเกินราวที่สุดดดดดดดดด  #binjincouple #binjinwedding #ใต้เตียงดารา  https://t.co/xwBD3B4Gox',
		labels: ['none'],
	},
	{
		date: '2022-04-11 17:24:54',
		content:
			'ความเอย ความรักนะ วันนี้ต้นสังกัดของทั้งคู่ลงภาพวันแต่งงานฮยอนบิน ซนเยจิน แบบ Official ให้แฟนๆได้ร่วมยินดีอีกรอบ  หล่อ สวย คู่รักสวรรค์สร้างที่แท้ทรู รูปฟีลเหมือนจากซีรีส์อะค่ะ 55555  วันนี้ทั้งคู่ก็ได้บินไปฮันนีมูนกันที่ LA ด้วยยยย   #binjincouple #binjinwedding #ใต้เตียงดารา  https://t.co/GkdS3EXFXP',
		labels: ['none'],
	},
	{
		date: '2022-04-11 10:54:12',
		content:
			'จากเจ้าหนูน้อยบรู๊คลินในวันนั้น สู่การเป็นเจ้าบ่าวในเมื่อวานนี้  #ใต้เตียงดารา  https://t.co/iM0EwDlflP',
		labels: ['none'],
	},
	{
		date: '2022-04-08 12:44:31',
		content:
			'พาน้องใหม่เพิ่งเข้าวงการมาฝากตัว น้องไอซ์ อภิษฎา 18 ขวบ   เรียกชีไอซ์ไม่ได้ พี่ไอซ์ก็ไม่ได้ ลุคผมบ๊อบสั้นนี้ต้องเรียกน้องไอซ์เท่านั้นจริงๆ ทรงนี้คือปลดล็อคสกินหน้าเด็กมาก   #ใต้เตียงดารา  https://t.co/pzX8XcBSPt',
		labels: ['health'],
	},
	{
		date: '2022-04-07 19:07:26',
		content:
			'แจกสกินนี้ฟรียกเซิร์ฟในวันที่ 10 เมษา 65 นอกจากยังมีแจกสกินไทยตัวเก่าและฮีโร่ถาวรอีกด้วย 10 เมษาเข้า RoV ไปตีป้อมมันส์สาดกัน   https://t.co/hetj0PHMd7  #RoV10เมษาตีป้อมมันส์สาด #RoVสกินไทยฟรี #มินพีชญาวีรมัศยาไอริ  https://t.co/us5HaT8uub',
		labels: ['health'],
	},
	{
		date: '2022-04-07 19:07:21',
		content:
			'ปลาที่ไหนจะสู้ ปลากัดไทย วีรมัศยา ไอริ ลุคนี้โคฟ by #มินพีชญา  สกินไทยใหม่ที่ #RoV แจกฟรีทุกปี ปีนี้ก็ไม่ผิดหวังงง จึ้งมากทั้งเสื้อผ้า หน้าผม เอฟเฟกต์ต่างๆ  #RoV10เมษาตีป้อมมันส์สาด #RoVสกินไทยฟรี #มินพีชญาวีรมัศยาไอริ  https://t.co/EMehaBMTI9',
		labels: ['none'],
	},
	{
		date: '2022-04-07 16:05:38',
		content:
			'ช่วงนุ้ง #ไอซ์พาริส กับกลปามีดของเขา   ที่ลุ้นกว่าว่าจะใช่ไพ่ใบที่เซ็นต์ไว้ไหม คือลุ้นตอนปามีดนะ เสียวแทน 55555    #MagicWars #ศึกมายากล  https://t.co/IF8gIZTmUs',
		labels: ['none'],
	},
	{
		date: '2022-04-07 16:01:37',
		content:
			'พ่อมด #มิวศุภศิษฏ์ ในรายการ #ศึกมายากล เมื่อคืนก็คือทำให้ว้าวสุดๆกับกลสื่อจิต   ตอนชีปุ๊กลุกบอกได้ยินเหมือนเสียงชีกวางท่องชื่อหนังอยู่คือทำยังไงงงก๊อนนน   #MagicWars #MagicWarsxMEW   https://t.co/IkQYds5JJW  https://t.co/sHL4tV0yaO',
		labels: ['none'],
	},
	{
		date: '2022-04-18 13:18:36',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ อาคาร Mint Tower ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-07 15:48:44',
		content:
			'วันเกิดชีวุ้นเส้นที่ผ่านมาแก๊งนางฟ้าเลยรวมตัวกันอีกครั้งกับมิตรภาพ 20 ปี   ทางเราที่เห็นรูปจะผ่านไปกี่ปีๆๆๆหน้าชีแต่ละคนก็คือสวยจึ้งไม่เปลี่ยนยอมมาก   แต่ที่เปลี่ยนไป เป็นตำนานแบบใหม่แบบสับ คือการพกยาธาตุน้ำขาวไปกินขับลม คลายจุกแน่นเฟ้อ ตอนอิ่มแล้วนะแม่ 5555555  https://t.co/b7WjxZbcBQ',
		labels: ['health'],
	},
	{
		date: '2022-04-05 16:30:32',
		content:
			'ก็เป็นว่าที่บ่าวสาวพ่วงด้วยว่าที่ปะป๊า หม่าม๊า เลยสิคะ!!!  ยินดีกับชี #ดิวอริสรา และฮีเซบาสเตียนด้วยจ้าาาาา   #ใต้เตียงดารา  https://t.co/DOGbNqS5gb',
		labels: ['none'],
	},
	{
		date: '2022-04-05 12:48:47',
		content:
			'และก็เดินทางมาถึงตอนจบกับมหากาพย์เจ้าสาวมือปราบ ชีจั๊กจั่นและเพื่อนเคยสนิทนก อุษณีย์   วันนี้ชีนกได้โพสขอโทษ จั๊กจั่น ,คุณเค และครอบครัว ที่ทำให้ปชช.เข้าใจผิด รวมถึงที่เคยกล่าวหาว่าคุณเคมีภรรยาอยู่แล้ว   โดยจะโพสขอโทษไม่ต่ำกว่า 30 วัน และจ่ายเงินเยียวยา 1ล้านบาท เรียบร้อยแล้ว  https://t.co/TSuxdkBnVz',
		labels: ['none'],
	},
	{
		date: '2022-04-04 18:29:26',
		content:
			'#ศึกมายากล พุธนี้รอดูเลอ  นี่ยกให้เป็นคู่เด็ดในใจ เพราะน้อง #มิวศุภศิษฏ์ ต้องมาเจอกับน้อง #ไอซ์พาริส ขาดเธอก็เหงาขาดเขาก็คงเสียใจ    ตัดใจเชียร์ใครไม่ได้เลยทั้งเรื่องแข่งมายากล ทั้งเรื่องความหล่อความไอ้ต้าวน่ารัก หนักใจกว่ากรรมการก็ใจชั้นนี่แหละ!  https://t.co/n2aqdmmpsT',
		labels: ['none'],
	},
	{
		date: '2022-04-02 19:57:57',
		content:
			'แม่ฟื้นแล้ว แม่มาหย่อนภาพน้องแอบิเกลแล้วน้าาาาาา  น่ารักมากกกก จากในรูปที่แม่ลงมีความแฝดพี่พายุเบาๆ 55555555  #ชมพู่อารยา #สายฟ้าพายุ #ใต้เตียงดารา  https://t.co/MapcSizCT1',
		labels: ['religion'],
	},
	{
		date: '2022-04-02 13:21:19',
		content:
			'เติมเน็ตมาเพื่อมองดูคนเค้ารักกัน คู่พี่ก๊อต จิรายุ - ชีโบว์ เบญจวรรณ ก็คือหวานไม่แผ่ว   เอ็นดูสกิลอ้อนแฟนของพี่ก๊อตเขานะ แค่ชีโบว์ถือกล้องเฉยๆ = มงแล้ว ชนะเลิศแล้ว   #ใต้เตียงดารา  https://t.co/UMZ9KreiPo',
		labels: ['none'],
	},
	{
		date: '2022-04-28 09:21:57',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-28 09:21:39',
		content:
			'อนาคตของกรุงเทพฯ ควรเริ่มต้นจากความรู้ ความคิดสร้างสรรค์ และควรเริ่มจากการหาเสียงที่โปร่งใส ไม่สาดโคลนครับ   #ชัชชาติ #ชัช8าติ  https://t.co/9i8MBlgGD7',
		labels: ['first_name', 'politics'],
	},
	{
		date: '2022-04-27 20:19:17',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ อาคาร Mint Tower ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-27 20:18:29',
		content:
			'“โครงสร้างดี"คือการวางรากฐานให้เมืองดีขึ้นเพื่อคุณภาพชีวิตของประชาชน เน้นการพัฒนาเส้นเลือดฝอยให้เรื่องใกล้ตัวดีขึ้น ครอบคลุมประเด็นที่อยู่อาศัย ระบายน้ำ และผังเมือง  อ่านชุดนโยบายโครงสร้างดีได้ที่  https://t.co/5GGmHgBPi5 ครับ  #ชัชชาติ #ชัช8าติ  https://t.co/yA5kn2J7W4',
		labels: ['first_name', 'politics'],
	},
	{
		date: '2022-04-26 13:30:31',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ อาคาร Mint Tower ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-26 13:30:02',
		content:
			'เดือนนี้ได้เล่นเกมของคนกรุงเทพฯ กันหรือยัง? ติดตามตอนต่อไป เร็วๆ นี้ครับ  https://t.co/G02nSKLtrW  #ชัชชาติ #ชัช8าติ',
		labels: ['first_name', 'politics'],
	},
	{
		date: '2022-04-24 13:08:34',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ อาคาร Mint Tower ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330 จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-24 13:07:52',
		content:
			'หัวใจของการขับเคลื่อนทุกนโยบายให้มีประสิทธิภาพ คือการ “บริหารจัดการดี”  มีประสิทธิภาพ โปร่งใส ไม่ส่วย ไม่เส้น ประชาชนมีส่วนร่วม และรับใช้ประชาชนทุกคนอย่างเท่าเทียม  อ่านชุดนโยบาย “บริหารจัดการดี” ต่อได้ที่  https://t.co/5GGmHgBPi5 ครับ  #ชัชชาติ #ชัช8าติ  https://t.co/B2k99HG5L7',
		labels: ['first_name', 'politics'],
	},
	{
		date: '2022-04-21 18:18:05',
		content:
			'ผลิตโดย ชัชชาติ สิทธิพันธุ์ ห้อง 310-312 เลขที่ 719 ถนนบรรทัดทอง แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330  จำนวน 1 ชุด ตามวันและเวลาที่ปรากฏส่งมาในครั้งนี้',
		labels: ['first_name', 'last_name', 'address', 'politics'],
	},
	{
		date: '2022-04-21 18:17:46',
		content:
			'เดินๆ อยู่ แล้วเจอเพื่อนที่สาทรครับ  #ชัชชาติ #ชัช8าติ  https://t.co/cA82tOuJuh',
		labels: ['first_name', 'politics'],
	},
];
